// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2-bz4","label":"Slider_label__2GVkg","container":"Slider_container__1Hqx5","slider":"Slider_slider__3QjrK","rangeValue":"Slider_rangeValue__3Ezt_"};